import { defaultTo, map } from "lodash";
import { AssessmentRecommendationModel, IModel, Model, ModelRecord, StorageContentModel } from "@common/models";

export interface IAssessmentReferralModel extends IModel {
    assessmentReferralId: number;
    name: string;
    description: string;
    sortOrder: number;
    isActive: boolean;
    attachmentStorageContentId: number | undefined;
    attachmentStorageContent: StorageContentModel | undefined;
    assessmentRecommendations: AssessmentRecommendationModel[];
}

export class AssessmentReferralModel extends Model implements ModelRecord<IAssessmentReferralModel> {
    assessmentReferralId: number;
    name: string;
    description: string;
    sortOrder: number;
    isActive: boolean;
    attachmentStorageContentId: number | undefined;
    attachmentStorageContent: StorageContentModel | undefined;
    assessmentRecommendations: AssessmentRecommendationModel[] = [];

    constructor(params?: Partial<IAssessmentReferralModel>) {
        super(params);
        this.assessmentReferralId = defaultTo(params?.assessmentReferralId, 0);
        this.name = defaultTo(params?.name, '');
        this.description = defaultTo(params?.description, '');
        this.sortOrder = defaultTo(params?.sortOrder, 0);
        this.isActive = defaultTo(params?.isActive, true);
        this.attachmentStorageContentId = defaultTo(params?.attachmentStorageContentId, undefined);
        this.attachmentStorageContent = params?.attachmentStorageContent ? new StorageContentModel(params.attachmentStorageContent) : undefined;
        map(params?.assessmentRecommendations, (ar) => { this.assessmentRecommendations.push(new AssessmentRecommendationModel(ar)) });
    }
}
